<template>
  <a-card :bordered="false">
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="pic" slot-scope="text">
        <span class="pic"><img :src="text"></span>
      </template>
      <template slot="type" slot-scope="text, record">
        <p>{{ text }}</p>
        <p>{{ record.stock.sku.specification }}</p>
      </template>
      <template slot="get_num" slot-scope="text,record">
        <a-input v-model.number="record.get_num" style="width:50px;" />
      </template>
      <template slot="schedule" slot-scope="text">
        {{ text ? '退换货' : '未处理' }}
      </template>
      <template slot="actual_quantity" slot-scope="text,record">
        {{ record.quantity - record.transit_stock + record.excess_inventory }}
      </template>

      <template slot="action" slot-scope="text, record">
        <div class='editable-row-operations'>
          <a @click="handleList(record)">上架</a>
        </div>
      </template>
    </s-table>
  </a-card>
</template>
<script>

import STable from '@/components/table/'
import AInput from 'ant-design-vue/es/input/Input'
import { getWaystockDetail, addWaystock } from '@/api/stock'

export default {
  name: "WayGoodsList",
  components: {
    AInput,
    STable
  },
  data() {
    return {
      loading: false,
      get_num: 0,
      columns: [
        {
          title: '图片',
          dataIndex: 'pic_url',
          scopedSlots: { customRender: 'pic' },
        },
        {
          title: '名称',
          dataIndex: 'goods_name',
        },
        {
          title: 'sku',
          dataIndex: 'sku',
        },
        {
          title: '库存现量',
          dataIndex: 'unit_stock',
        },
        {
          title: '兑换规则',
          dataIndex: 'exchange_price'
        },
        {
          title: '下单数量',
          dataIndex: 'quantity'
        },
        {
          title: '在途数量',
          dataIndex: 'transit_stock'
        },
        {
          title: '实到数量',
          dataIndex: 'actual_quantity',
          scopedSlots: { customRender: 'actual_quantity' },
        },
        {
          title: '到货数量',
          dataIndex: 'get_num',
          scopedSlots: { customRender: 'get_num' },
        },
        // {
        //   title: '处理情况',
        //   dataIndex: 'schedule',
        //   scopedSlots: { customRender: 'schedule' },
        // }, 
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      loadData: params => {
        return getWaystockDetail({ ...params, id: this.$route.params.id, }).then(res => res)
      },
    }
  },
  methods: {
    handleList(row) {
      if (!row.get_num || row.get_num <= 0) {
        this.$message.error('请填写正确的到货数量')
        return
      }
      if (row.transit_stock < row.get_num) {
        this.$confirm({
          title: '超量到货',
          content: '填写的上架数量超过在途数量，是否确定超量到货？',
          onOk:()=> {
            return this.submit(row)
          },
          onCancel() { },
        });
      }else{
        this.submit(row)
      }
    },
    submit(row) {
      const params = {
        quantity: row.get_num,
        id: row.id
      }
      if(this.loading){
        return
      }
      this.loading = true
      return addWaystock(params).then(res => {
        this.$message.success('收货成功')
        this.$refs.table.refresh()
      })
      .finally(()=>{
        this.loading = false
      })
    }
  },
}
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}

.pic>img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>